import React, { useEffect, useState } from 'react';
import { StepFlipProps } from '../types';
import { selectRandomOption } from '../utils/random';

const StepFlip: React.FC<StepFlipProps> = ({ state, onUpdate, onNext }) => {
  const [isFlipping, setIsFlipping] = useState(true);
  const [showRevealButton, setShowRevealButton] = useState(false);
  const [resultRevealed, setResultRevealed] = useState(false);

  // Start coin animation when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFlipping(false);
      setShowRevealButton(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleRevealResult = async () => {
    setResultRevealed(true);

    // Select random option
    const chosenIndex = selectRandomOption(state.options);

    // Update state with chosen option and loading status
    onUpdate({ chosenIndex, aiStatus: 'loading' });


    onNext();
  };

  return (
    <div className="coin-container">
      <div className={`coin ${isFlipping ? 'flipping' : ''}`}></div>
      <p style={{ marginTop: '20px', textAlign: 'center', color: '#666' }}>
        {isFlipping
          ? 'Notice what you hope it lands on.'
          : 'The coin has landed!'}
      </p>
      {showRevealButton && !resultRevealed && (
        <button
          className="btn"
          onClick={handleRevealResult}
          style={{ marginTop: '20px' }}
        >
          Reveal Result
        </button>
      )}
    </div>
  );
};

export default StepFlip;
